import { Observable } from "rxjs";
import { getApiClient } from './ProductService.js';
import { IProductInfo } from '../interfaces/IProductInfo.js';
import { ISupercedeProduct } from "@wbmason/cart-service/interfaces/supercedeProduct.js";
import { ISupersedeLoggingItem } from '../interfaces/ISupersedeLogging.js';
import { ICartItem } from "@wbmason/cart-service/interfaces/cartItem.js";
import { SupercedeSubType } from '../constants/enums.js';

export const SupersedeLoggingService = {
    logSupercede(supersedeItem: ISupercedeProduct[], product: IProductInfo, cartItem: ICartItem): Observable<boolean> {
        const sourceProduct = supersedeItem[0].sourceProduct;
        const supercedeType = supersedeItem[0].isHardSub ? SupercedeSubType.Hard : product.itemId === sourceProduct.itemId ? SupercedeSubType.NotTaken : SupercedeSubType.Soft;

        const logItem: ISupersedeLoggingItem = {
            supItemId: product.itemId,
            supUnitId: product.unitId,
            supPrice: product.unitPrice,
            supType: supercedeType,
            origItemId: sourceProduct.itemId,
            origUnitId: sourceProduct.unitId,
            origPrice: sourceProduct.sellPrice,
            origCouponOfferId: sourceProduct.couponOfferCode,
            quantity: cartItem.lastQtyAdded || 1,
            cartLineRecId: cartItem.cartLineRecId,
            superCedeItems: supersedeItem
        };

        const url = "/cart/api/SupercedeLogging/LogSupercede";
        const config = { withCredentials: true };
        const observable: Observable<boolean> = getApiClient().post(url, logItem, config);
        return observable;
    }
};